import React from 'react';
import { useTranslation } from 'react-i18next';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import ScreenContainer from 'components/containers/ScreenContainer';
import TabPanel from 'components/TabPanel/TabPanel';
import ListSoldProductsTable from 'components/ListSoldProductsTable';
import ListSoldOrdersTable from 'components/ListSoldOrdersTable';
import ListSoldProductsByLocationTable from 'components/ListSoldProductsByLocationTable';
import ListSoldProductsByVendorTable from 'components/ListSoldProductsByVendorTable';
import ListSoldInAppProductsTable from 'components/ListSoldInAppProductsTable';

import useLoggedAndRules from 'hooks/useLoggedWithRules';
import { useSoldProductsFilters } from 'hooks/useSoldProductsFilters';

import { edit, list } from 'config/rules';
import { useSearchParams } from 'react-router-dom';

function SoldProducts() {
	// Shared filter state across all tabs using reducer
	const { filters, dispatch } = useSoldProductsFilters();

	const user = useLoggedAndRules();

	const [searchParams, setSearchParams] = useSearchParams({
		index: '0',
	});
	const { t } = useTranslation();
	const [value, setValue] = React.useState(searchParams.get('index') ? Number(searchParams.get('index')) : 0);

	const rules: ServerRules = user?.rules || {};

	const orderList = list(rules['Order']);
	const inAppSaleEdit = edit(rules['InAppSale']);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
		setSearchParams({ index: `${newValue}` });
	};

	return (
		<ScreenContainer title={`${t('common:SoldProducts')}`}>
			<Tabs value={value} onChange={handleChange} sx={{ mb: 2 }} variant="scrollable">
				{orderList && <Tab label={`${t('common:ListSoldProducts')}`} />}
				{orderList && <Tab label={'Listado de Órdenes'} />}
				{orderList && <Tab label={`${t('common:ProductsSoldByLocation')}`} />}
				{orderList && <Tab label={`${t('common:ProductsSoldByVendor')}`} />}
				{inAppSaleEdit && <Tab label={'Compras integradas'} />}
			</Tabs>

			{orderList && (
				<TabPanel value={value} index={0}>
					<ListSoldProductsTable filters={filters} dispatch={dispatch} />
				</TabPanel>
			)}
			{orderList && (
				<TabPanel value={value} index={1}>
					<ListSoldOrdersTable filters={filters} dispatch={dispatch} />
				</TabPanel>
			)}
			{orderList && (
				<TabPanel value={value} index={2}>
					<ListSoldProductsByLocationTable filters={filters} dispatch={dispatch} />
				</TabPanel>
			)}
			{orderList && (
				<TabPanel value={value} index={3}>
					<ListSoldProductsByVendorTable filters={filters} dispatch={dispatch} />
				</TabPanel>
			)}
			{inAppSaleEdit && (
				<TabPanel value={value} index={orderList ? 4 : 0}>
					<ListSoldInAppProductsTable />
				</TabPanel>
			)}
		</ScreenContainer>
	);
}

export default SoldProducts;
